<template>
    <vue-final-modal name="update-temp-pwd-modal" class="verification-number-modal modal-common" v-model="show"
                     :width="'560px'" :height="'auto'" :click-to-close="false" :esc-to-close="false"
                     @before-open="handlerBeforeOpen" @before-close="handlerBeforeClose">
        <div class="modal-content-common modal-content-pwd">
            <div class="box-modal-header align-center">
                <div class="modal-title">
                    임시 비밀번호가 발급되었습니다.
                    <br>
                    새로운 비밀번호로 변경해주세요.
                </div>
            </div>
            <Form ref="passwordWriteFrom">
                <div>
                    <div class="box-row el-input-common">
                        <div class="box-title-common">변경 비밀번호</div>
                        <Field v-model="pwd" name="pwd" v-slot="{ field, errorMessage }" :rules="validatePassword">
                            <el-input v-model="pwd" v-bind="field" name="pwd" maxlength="500"
                                      @input="setData('pwd', pwd)" type="password"
                                      placeholder="변경 비밀번호 입력" clearable></el-input>
                            <div class="caption-common" v-if="errorMessage">{{ errorMessage }}</div>
                        </Field>
                    </div>
                    <div class="box-row el-input-common">
                        <div class="box-title-common">변경 비밀번호 확인</div>
                        <Field v-model="pwdConfirm" name="pwdConfirm" v-slot="{ field, errorMessage }"
                               :rules="validatePasswordConfirm">
                            <el-input v-model="pwdConfirm" v-bind="field" name="pwdConfirm" maxlength="500"
                                      @input="setData('pwdConfirm', pwdConfirm)" type="password"
                                      placeholder="변경 비밀번호 확인 입력" clearable
                                      @keypress.enter.native="checkValidate()"></el-input>
                            <div class="caption-common" v-if="errorMessage">{{ errorMessage }}</div>
                        </Field>
                    </div>
                </div>
            </Form>
            <div class="btn-wrap pt20 pb20">
                <el-button class="btn-white" @click="modalClose()">닫기</el-button>
              <el-button class="btn-blue" @click="checkValidate()">변경</el-button>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
import {Form, Field} from 'vee-validate';
import validateMixins from "@/mixins/validateMixins.js";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import {logout} from "@/mixins/Auth";

export default {
    name: "UpdateTempPwdModal",
    mixins: [validateMixins, alertMixins],
    components: {Form, Field},
    data() {
        return {
            show: false,
            pwd: '',
            pwdConfirm: '',
            isRunning: false,
        }
    },
    methods: {
        handlerBeforeOpen() {
            this.show = true;
        },
        handlerBeforeClose() {
            this.show = false;
            this.pwd = '';
            this.pwdConfirm = '';
            this.isRunning = false;
        },
        modalClose() {
            this.$vfm.hide('update-temp-pwd-modal');
        },
        setData(key, value) {
            this[key] = value;
        },
        validatePassword(value) {
            if (this.isRequired(value)) {
                return '비밀번호를 입력해주세요.';
            }
            if (this.isPassword(value)) {
                return '비밀번호는 영문, 숫자, 특수문자를 포함한 8~16자로 입력해주세요';
            }
            return true;
        },
        validatePasswordConfirm(value) {
            if (this.isRequired(value)) {
                return '비밀번호를 재입력해주세요.';
            }
            if (this.isPassword(value)) {
                return '비밀번호는 영문, 숫자, 특수문자를 포함한 8~16자로 입력해주세요';
            }
            if (this.pwd !== value) {
                return '비밀번호가 일치하지 않습니다.';
            }
            return true;
        },
        async checkValidate() {
            if (this.isRunning) {
                return false;
            }

            const validateResult = await this.$refs.passwordWriteFrom.validate();
            if (!validateResult.valid) {
                this.errorAlert('입력 정보를 확인해주세요.');
                return false;
            }

            this.isRunning = true;
            await this.runSave();
        },
        async runSave() {
            EventBus.$emit('apiLoading', true);
            const params = {
                mbPassword: this.pwd,
                mbPasswordConfirm: this.pwdConfirm,
            };

            try {
                const res = await this.$api.$member.updateMemberPwd(params);
                if (res.code !== 1) {
                    EventBus.$emit('apiLoading', false);
                    this.isRunning = false;
                    this.errorAlert('비밀번호 변경 실패하였습니다.');
                    return false;
                }

                EventBus.$emit('apiLoading', false);
                this.isRunning = false;
                this.createAlert({
                    content: '비밀번호가 변경되었습니다.\n새 비밀번호로 다시 로그인해주세요.',
                    hide: () => {
                        this.modalClose();
                        this.$store.dispatch('userInfo/initUserInfo', {});
                        logout(this);
                    }
                });
            } catch (e) {
                EventBus.$emit('apiLoading', false);
                this.isRunning = false;
                console.log(e);
            }
        },
    },
}
</script>

<style scoped></style>
